<template>
<div>

<div class="row">
		<div class="col-3 left" v-if="ititle">{{ititle}}</div>
		<div class="col-7">
			<mt-button @click="showaction()">{{fy}}</mt-button>
		</div>
</div>

<mt-actionsheet :actions="actions" v-model="sheetVisible"></mt-actionsheet>

</div>	
</template>

<style scoped>
.mint-button--default{height:2rem;margin-top:.4rem; }
.row{background: white;}
.left{height: 3rem;line-height: 3rem;text-align: center;font-size: 1.1rem;letter-spacing:0;}
.gray{color:rgb(117,117,117);}	
</style>

<script>

export default{
	props:{
        ititle:{type:String,default:"体检分院"},
        hos:{type:String,default:"请选择体检分院"},
        change:{type:Number,default:1},//通过监听change字段来修改hos
        isbook:{trype:Number,default:0},//1预约时，屏蔽分院,0非预约时，不屏蔽
	},
	data(){
		return {
			fy:"请选择体检分院",
			actions:[],
            sheetVisible:false,
		}
    },
	watch:{
		hos:function(d){
               if(d){
                    this.fy=d;
               }   
        },
        change(d){
            if(this.hos){
                this.fy=this.hos
            }
        }
    },
    created:function(){
        this.init();
        if(this.hos){
             this.fy=this.hos;
        }
    },
	methods:{
		haha:function(e){
            this.fy=e.name;
			this.$emit("select",e.name);
		},
		init:function(){
            var _this=this;
            var url=this.isbook==1?"hospital":"get_diqu";
			axios.get(mydata.api+"api/"+url).then(function(d){
				console.log("hos",d.data,_this.isbook)
				if(d.data.status==1){
                    var list=d.data.info;
					var re=[];
					var len=list.length;
					for(var i=0;i<len;i++){
						re[i]={
							name:list[i],
							method:_this.haha
						}
					}
					_this.actions=re;
				}else{
					_this.$toast(d.data.info);
				}
			})
		},
		showaction:function(){
			this.sheetVisible=true;
		}
	}
}	
</script>


// WEBPACK FOOTER //
// src/lib/hos.vue